export default __webpack_public_path__ + "static/media/hands-20.79f1a70d.png";